import { memo } from "react";

const BzCard = ({ className, ...props }) => {
    return (
        <div className={className} {...props}>{
            props.children
        }</div>
    )
}


export default memo(BzCard);
